import { createSelector, createSlice } from '@reduxjs/toolkit';
import { RootState } from 'app/store';
import { SubcsriptionSliceInitialState } from './subscriptionTypes';
import {
  addSubscription,
  cancelSubscription,
  getSubscriptionInfoById,
  getSubscriptionInfoByOrganozationId,
  reactivateSubscription,
  setSubscriptionInfo,
  updateSubscriptionInfo
} from './subscriptionActions';

const initialState: SubcsriptionSliceInitialState = {
  subscriptionInfo: null,
  isLoading: false,
};

export const subscriptionSlice = createSlice({
  name: '@@subscription',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(setSubscriptionInfo, (state, action) => {
      state.subscriptionInfo = action.payload;
    });

    builder.addCase(getSubscriptionInfoByOrganozationId.fulfilled, (state, action) => {
      state.subscriptionInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getSubscriptionInfoByOrganozationId.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getSubscriptionInfoByOrganozationId.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(getSubscriptionInfoById.fulfilled, (state, action) => {
      state.subscriptionInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(getSubscriptionInfoById.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(getSubscriptionInfoById.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(updateSubscriptionInfo.fulfilled, (state, action) => {
      state.subscriptionInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(updateSubscriptionInfo.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(updateSubscriptionInfo.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(addSubscription.fulfilled, (state, action) => {
      state.subscriptionInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(addSubscription.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(addSubscription.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(cancelSubscription.fulfilled, (state, action) => {
      state.subscriptionInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(cancelSubscription.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(cancelSubscription.pending, (state) => {
      state.isLoading = true;
    });

    builder.addCase(reactivateSubscription.fulfilled, (state, action) => {
      state.subscriptionInfo = action.payload;
      state.isLoading = false;
    });
    builder.addCase(reactivateSubscription.rejected, (state) => {
      state.isLoading = false;
    });
    builder.addCase(reactivateSubscription.pending, (state) => {
      state.isLoading = true;
    });
  },
});

export const subscriptionInfoSelector = createSelector(
  [(state: RootState) => state.subscription.subscriptionInfo],
  (info) => info
);

export const isLoadingSubscriptionInfoSelector = createSelector(
  [(state: RootState) => state.subscription.isLoading],
  (info) => info
);
